module.exports = __webpack_public_path__ + "img/logo.41862480.png";